import { WithStyles, withStyles } from '@mui/styles';
import {
    AgGridColumnDef,
    GridSettingsContext as IGridSettingsContext,
    SortModel
} from '@tassat/common-definitions';

import { GridModelContext } from './gridModelContext';
import { SideList } from './sideList';
import { muiStyles } from './sideListStyles';

type GridOptions = IGridSettingsContext['options'];
export interface SideListGridOptions extends GridOptions {
    idField: string;
    sortModel?: null | SortModel;
    footer?: {
        display: boolean;
    };
}

export interface ISideListProps extends WithStyles<typeof muiStyles> {
    CellRenderer?: React.ElementType;
    rowData: any[];
    columnDefs?: AgGridColumnDef[];
    gridOptions: SideListGridOptions;
}

export default withStyles(muiStyles)(SideList);
export { GridModelContext };